import React from 'react';

import { Divider } from '@schoolinks/ui-components';

import { bool, shape } from 'prop-types';

import { NavLink } from 'react-router-dom';

import SchoolinksLogo from 'components/Common/Icons/SchoolinksLogo';
import { getLogoLinkTo } from 'components/Common/LayoutV2/utils';
import useModal from 'hooks/useModal';

import useUserRedux from 'hooks/useUserRedux';

import s from './HomeItem.css';

const HomeItem = props => {
  const { style, withDivider, isOnboarding, ...restProps } = props;
  const { hideModal } = useModal();
  const { isStudent, isDemoStudent, currentUserMode, isLoggedIn } =
    useUserRedux();

  const linkTo = getLogoLinkTo({
    isOnboarding,
    isStudent,
    isDemoStudent,
    currentUserMode,
    isLoggedIn,
  });

  return (
    <>
      <NavLink
        className={s.schooLinksLogo}
        onClick={hideModal}
        style={style}
        to={linkTo}
        {...restProps}
        variant={null}
        aria-label="Go to homepage"
      >
        <SchoolinksLogo />
      </NavLink>
      {withDivider && <Divider className={s.divider} lineOnly />}
    </>
  );
};

HomeItem.propTypes = {
  style: shape({}),
  withDivider: bool,
  isOnboarding: bool,
};

HomeItem.defaultProps = {
  style: {},
  withDivider: true,
  isOnboarding: false,
};

export default HomeItem;
